import { useCouponAndModalForms } from '../../../couponAndModalFormsContext';
import { CheckInput } from '../../checkInput'
import { useCouponValidity } from '../couponValidityContext';

import { Container } from './style';

export function InputNoEndDate() {
    const { noEndDate, setNoEndDate } = useCouponValidity() 

    const {  couponDatasToCreateOrEdit, setCouponDatasToCreateOrEdit, } = useCouponAndModalForms()
    
    function setEndDate() {
        if(!noEndDate === true)
            setCouponDatasToCreateOrEdit({...couponDatasToCreateOrEdit, noEndDate: true, endDate: ''})
        else
            setCouponDatasToCreateOrEdit({...couponDatasToCreateOrEdit, noEndDate: false, endDate: ''})
    }


    return (
            <Container>
                <div className="container">
                    <CheckInput 
                        handleClickCheck={setNoEndDate}
                        inputValueToChange={noEndDate}
                        setOthersClick={setEndDate}
                    />
                    <p>Sem prazo de expiração</p>
                </div>
            </Container>
    )
}
